export default {
      id: "financial-risk-3-usage",
      viewBox: "0 0 26 32",
      url: __webpack_public_path__ + "sprite.svg#financial-risk-3",
      toString: function () {
        return this.url;
      }
    }